import { Grid} from "@mui/material";
import ReactPlayer from 'react-player'
//import ReactHlsPlayer from 'react-hls-player';
import {
  getParams,
  navigate,
  sendGetRequest
} from "../utils/utils";
import EditPage from "./component/edit-page";
import 'shaka-react-video-player/dist/controls.css';
import 'shaka-react-video-player/dist/themes.css';
import ShakaPlayer from "shaka-react-video-player";
import { useEffect, useState } from "react";


const LinkPlayer = () => {
  const { uuid, type, source } = getParams();
  const [iframe, setIframe] = useState(false);
  const isStream = type === "stream";
  const title = `${isStream ? "Streaming content now" : "Play content"}`;
  var [urls, setUrls] = useState({url: null, streamUrl: null, watchUrl: null});
  const [status, setStatus] = useState({
    error: false,
    loading: true,
    message: null,
  });

  const executeFetch = () => {
    sendGetRequest(`contents?uuid=${uuid}`, (loading) => setStatus({ ...status, loading }),
      (data) => {
        setIframe(data.type === "books");
        setUrls({ ...urls, ...data});
      });
  };

  useEffect(
    () => executeFetch(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [uuid]
  );

  return (
    <EditPage
      title={title}
      status={{}}
      btnLabel={""}
      onSave={() => {}}
      validated={false}
      backgroundColor={"#000000"}
      onFinish={() => {}}
      removeTopPadding={true} 
      onBack={() => navigate(source, true)}
    >

      {isStream && urls.streamUrl && status.loading === false && (<Grid item xs={12} xl={12}>
        <ShakaPlayer
          src={urls.streamUrl}
          autoPlay
          width="100%"
          height="auto"
          hlsConfig={{
            maxLoadingDelay: 4,
            minAutoBitrate: 0,
            lowLatencyMode: true,
          }}
        />
      </Grid>)}

      {!isStream && !iframe && (urls.url || urls.watch)  && status.loading === false && (<Grid item xs={12} xl={12}>
        <ReactPlayer url={urls.watchUrl || urls.url} controls={true} width={"100%"} muted={true} height={500}/>
      </Grid>)}

      {iframe && (<Grid item xs={12} xl={12}>
        <iframe
          src={urls.url}
          width="100%"
          height="650"
          style={{ border: "none" }}
          title=""
        />
      </Grid>)}
    </EditPage>
  );
};

export default LinkPlayer;